<template>
	<div>
		<h1>Comparaison de fichiers XML</h1>
		<div v-if="file_1 && file_2">
			<b-checkbox v-model="only_diff"
				>Afficher que les différences</b-checkbox
			>
			<b-button @click="generate_docx">Génerer docx</b-button>
			<br /><br />
		</div>
		<b-container>
			<b-row>
				<b-col cols="6">
					<b-form-file
						@change="file_1_input"
						placeholder="Importer un fichier"></b-form-file>
					<div id="jsoneditor-1"></div>
					<span v-for="(result, index) in result_1" :key="index">
						<pre :style="'color:' + result.color + '; margin:0;'">{{
							result.text
						}}</pre>
					</span>
				</b-col>
				<b-col cols="6">
					<b-form-file
						@change="file_2_input"
						placeholder="Importer un fichier"></b-form-file>
					<div :id="'jsoneditor-2'"></div>
					<span v-for="(result, index) in result_2" :key="index">
						<pre :style="'color:' + result.color + '; margin:0;'">{{
							result.text
						}}</pre>
					</span>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
	import store from "../store";

	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	import { JSONEditor } from "@json-editor/json-editor";
	import { Document, Packer, Paragraph, TextRun } from "docx";
	import { saveAs } from "file-saver";

	var convert = require("xml-js");
	var format = require("xml-formatter");
	const _ = require("underscore");

	export default {
		name: "compare_file",
		data() {
			return {
				editor_1: null,
				editor_2: null,
				file_1: "",
				file_2: "",
				json_1: {},
				json_2: {},
				i1: 0,
				i2: 0,
				result_1: [],
				result_2: [],
				only_diff: true,
				json_diff: [],
				doc: [],
			};
		},
		watch: {
			only_diff: {
				handler: function (newVal, oldVal) {
					this.start_diff();
				},
			},
		},
		methods: {
			generate_docx_elem: async function (elem, name) {
				var keys = Object.keys(elem.child);
				if (keys.length != 0) {
					for (var i = 0; i < keys.length; i++) {
						if (Object.keys(elem.child[keys[i]].child).length > 0) {
							this.doc.push(
								new Paragraph({
									children: [
										new TextRun({
											text: keys[i],
											bold: true,
										}),
									],
								})
							);
						}
						this.generate_docx_elem(elem.child[keys[i]], keys[i]);
					}
					this.doc.push(
						new Paragraph({
							children: [
								new TextRun({
									text: "",
								}),
							],
						})
					);
				} else {
					var text = name + " : ";
					this.doc.push(
						new Paragraph({
							children: [new TextRun(name + " : ")],
						})
					);

					if (elem.hasOwnProperty("file_1")) {
						if (!elem.file_1) {
							this.doc.push(
								new Paragraph({
									children: [new TextRun("   valeur vide")],
								})
							);
						} else {
							this.doc.push(
								new Paragraph({
									children: [
										new TextRun("   " + elem.file_1),
									],
								})
							);
						}
					} else {
						this.doc.push(
							new Paragraph({
								children: [new TextRun("   pas de balises")],
							})
						);
					}

					if (elem.hasOwnProperty("file_2")) {
						if (!elem.file_2) {
							this.doc.push(
								new Paragraph({
									children: [new TextRun("   valeur vide")],
								})
							);
						} else {
							this.doc.push(
								new Paragraph({
									children: [
										new TextRun("   " + elem.file_2),
									],
								})
							);
						}
					} else {
						this.doc.push(
							new Paragraph({
								children: [new TextRun("   pas de balises")],
							})
						);
					}
				}
			},
			generate_docx: async function () {
				this.doc = [];

				this.generate_docx_elem(this.json_diff, "");

				const doc = new Document({
					sections: [
						{
							properties: {},
							children: this.doc,
						},
					],
				});

				Packer.toBlob(doc).then((blob) => {
					//console.log(blob);
					saveAs(blob, "compare_xml.docx");
					//console.log("Document created successfully");
				});
			},
			file_1_input: async function (event = null) {
				var self = this;

				var file = null;
				if (event.dataTransfer) file = event.dataTransfer.files[0];
				else file = event.target.files[0];

				var reader = new FileReader();
				reader.onload = function (event) {
					if (reader.result)
						self.editor_1.setValue(
							format(reader.result, {
								indentation: "  ",
								collapseContent: true,
								filter: (node) => node.type !== "Comment",
								lineSeparator: "\n",
							})
						);
				};
				reader.readAsText(file);
			},
			file_2_input: async function (event = null) {
				var self = this;

				var file = null;
				if (event.dataTransfer) file = event.dataTransfer.files[0];
				else file = event.target.files[0];

				var reader = new FileReader();
				reader.onload = function (event) {
					if (reader.result)
						self.editor_2.setValue(
							format(reader.result, {
								indentation: "  ",
								collapseContent: true,
								filter: (node) => node.type !== "Comment",
								fullTagEmptyElement: true,
								lineSeparator: "\n",
							})
						);
				};
				reader.readAsText(file);
			},
			start_diff() {
				this.result_1 = [];
				this.result_2 = [];
				this.i1 = 0;
				this.i2 = 0;
				this.json_diff = [];
				this.diff(0, this.json_1, this.json_2, true, true, []);

				var json_diff = {
					child: {},
					keys: {},
				};

				//console.log(JSON.stringify(this.json_diff))

				for (var i = 0; i < this.json_diff.length; i++) {
					var obj = json_diff;
					for (var j = 0; j < this.json_diff[i].path.length; j++) {
						var name = this.json_diff[i].path[j].name;
						var nb = null;
						if (name) {
							nb = this.json_diff[i].path[j].nb;
							if (!obj.child[name]) {
								obj.child[name] = { child: {}, keys: {} };
								obj.keys[name] = {};
								obj.keys[name][nb] = 1;
							} else if (
								!(
									j + 2 == this.json_diff[i].path.length &&
									!this.json_diff[i].path[j + 1].name
								)
							) {
								if (obj.keys[name][nb]) {
									if (obj.keys[name][nb] != 1)
										name = name + " " + obj.keys[name][nb];
								} else {
									var keys = Object.keys(obj.keys[name]);
									obj.keys[name][nb] = keys.length + 1;
									name = name + " " + (keys.length + 1);
									obj.child[name] = { child: {}, keys: {} };
								}
							}
							obj = obj.child[name];
						}
						if (j + 1 == this.json_diff[i].path.length) {
							if (this.json_diff[i].diff[0]) {
								if (
									this.json_diff[i].diff[0].text ||
									this.json_diff[i].diff[0].text == ""
								)
									obj.file_1 = this.json_diff[i].diff[0].text
										.replace(/\n/gi, "")
										.trim();
								else if (
									this.json_diff[i].diff[0].cdata ||
									this.json_diff[i].diff[0].cdata == ""
								)
									obj.file_1 = this.json_diff[i].diff[0].cdata
										.replace(/\n/gi, "")
										.trim();
								else if (this.json_diff[i].diff[0].name)
									obj.file_1 = "";
							}
							if (this.json_diff[i].diff[1]) {
								if (
									this.json_diff[i].diff[1].text ||
									this.json_diff[i].diff[1].text == ""
								)
									obj.file_2 = this.json_diff[i].diff[1].text
										.replace(/\n/gi, "")
										.trim();
								if (
									this.json_diff[i].diff[1].cdata ||
									this.json_diff[i].diff[1].cdata == ""
								)
									obj.file_2 = this.json_diff[i].diff[1].cdata
										.replace(/\n/gi, "")
										.trim();
								else if (this.json_diff[i].diff[1].name)
									obj.file_2 = "";
							}
						}
					}
				}

				this.json_diff = json_diff;
			},
			object_to_string(obj) {
				var keys = Object.keys(obj);
				var str = "";

				for (var i = 0; i < keys.length; i++) {
					if (i != 0) str += " ";
					if (keys[i]) str += `${keys[i]}="${obj[keys[i]]}"`;
				}

				if (str) str = " " + str + " ";

				return str;
			},
			xml_object_to_string(lvl, obj, end) {
				var str = "";
				if (obj.type == "element") {
					if (end) str = "<" + obj.name + "/>";
					else
						str =
							"<" +
							obj.name +
							this.object_to_string(obj.attributes) +
							">";
				} else if (obj.type == "cdata") {
					str = "<![CDATA[" + obj.cdata + "]]>";
				} else {
					str = obj.text.replace(/\n/g, " | ").trim();
				}
				if (str) {
					for (var i = 0; i < lvl; i++) {
						str = "  " + str;
					}
				}
				return str;
			},
			diff(lvl, json_1, json_2, write_1 = true, write_2 = true, path) {
				var color = "red";
				if (json_1.declaration && !json_2.declaration) {
					this.result_1.push({
						text:
							"<?xml" +
							this.object_to_string(
								json_1.declaration.attributes
							) +
							"?>",
						color,
					});
					this.result_2.push({
						text: " ",
						color,
					});
					this.i1++;
				} else if (!json_1.declaration && json_2.declaration) {
					this.result_1.push({
						text: " ",
						color,
					});
					this.result_2.push({
						text:
							"<?xml " +
							this.object_to_string(
								json_2.declaration.attributes
							) +
							" ?>",
						color,
					});
					this.i2++;
				} else if (json_1.declaration && json_2.declaration) {
					if (_.isMatch(json_1.attributes, json_2.attributes))
						color = "black";
					this.result_1.push({
						text:
							"<?xml " +
							this.object_to_string(
								json_1.declaration.attributes
							) +
							" ?>",
						color,
					});
					this.result_2.push({
						text:
							"<?xml " +
							this.object_to_string(
								json_2.declaration.attributes
							) +
							" ?>",
						color,
					});
					this.i1++;
					this.i2++;
				}

				var p = true;
				color = "red";

				var nb_diff = 0;

				var i_result_1 = this.result_1.length;
				var i_result_2 = this.result_2.length;
				var i_space_1 = [];
				var i_space_2 = [];

				if (!json_1.attributes) json_1.attributes = { "": "" };
				if (!json_2.attributes) json_2.attributes = { "": "" };

				if (json_1.type && !json_2.type) {
					nb_diff++;
					if (write_1) {
						//console.log("w11 (" + color + "): " + this.file_1[this.i1]);
						this.result_1.push({
							text: this.xml_object_to_string(lvl, json_1),
							color,
						});
						this.i1++;
						this.result_2.push({
							text: " ",
							color,
						});
						this.json_diff.push({
							path: path,
							diff: [
								{
									text: json_1.text,
									cdata: json_1.cdata,
									name: json_1.name,
									type: json_1.type,
								},
								null,
							],
							type: "only",
						});
					}
				} else if (!json_1.type && json_2.type) {
					nb_diff++;
					if (write_2) {
						//console.log("w21 (" + color + "): " + this.file_2[this.i2]);
						this.result_2.push({
							text: this.xml_object_to_string(lvl, json_2),
							color,
						});
						this.i2++;
						this.result_1.push({
							text: " ",
							color,
						});
						this.json_diff.push({
							path: path,
							diff: [
								null,
								{
									text: json_2.text,
									cdata: json_2.cdata,
									name: json_2.name,
									type: json_2.type,
								},
							],
							type: "only",
						});
					}
				} else if (json_1.type && json_2.type) {
					if (json_1.text) json_1.text = json_1.text.trim();
					if (json_2.text) json_2.text = json_2.text.trim();
					if (
						json_1.text == json_2.text &&
						json_1.cdata == json_2.cdata &&
						_.isMatch(json_1.attributes, json_2.attributes)
					) {
						color = "black";
					} else {
						this.json_diff.push({
							path: path,
							diff: [
								{
									text: json_1.text,
									cdata: json_1.cdata,
									name: json_1.name,
									type: json_1.type,
								},
								{
									text: json_2.text,
									cdata: json_2.cdata,
									name: json_2.name,
									type: json_2.type,
								},
							],
							type: "diff",
						});
						nb_diff++;
					}

					if (write_1) {
						//console.log("w12 (" + color + "): " + this.file_1[this.i1]);
						this.result_1.push({
							text: this.xml_object_to_string(lvl, json_1),
							color,
						});
						this.i1++;
						if (!write_2) {
							this.result_2.push({
								text: " ",
								color,
							});
						}
					}
					if (write_2) {
						//console.log("w22 (" + color + "): " + this.file_2[this.i2]);
						this.result_2.push({
							text: this.xml_object_to_string(lvl, json_2),
							color,
						});
						this.i2++;
						if (!write_1) {
							this.result_1.push({
								text: " ",
								color,
							});
						}
					}
				} else {
					nb_diff++;
					p = false;
				}

				if (!json_1.elements) json_1.elements = [];
				if (!json_2.elements) json_2.elements = [];

				if (
					(write_1 && json_1.elements.length > 0) ||
					(write_2 && json_2.elements.length > 0)
				) {
					var obj_key_1 = {};
					var keys_1 = [];
					for (var i = 0; i < json_1.elements.length; i++) {
						if (json_1.elements[i].name) {
							obj_key_1[json_1.elements[i].name] = i;
							keys_1.push(json_1.elements[i].name);
						}
					}

					//console.log(obj_key_1);
					//console.log(keys_1);

					var obj_key_2 = {};
					var keys_2 = [];
					for (var i = 0; i < json_2.elements.length; i++) {
						if (json_2.elements[i].name) {
							obj_key_2[json_2.elements[i].name] = i;
							keys_2.push(json_2.elements[i].name);
						}
					}

					//console.log(obj_key_2);
					//console.log(keys_2);

					var i1 = 0;
					var i2 = 0;
					var c = true;
					//console.log("--- loop ---")
					while (c) {
						if (
							i1 < json_1.elements.length &&
							i2 < json_2.elements.length
						) {
							if (
								json_1.elements[i1].type ==
									json_2.elements[i2].type &&
								json_1.elements[i1].name ==
									json_2.elements[i2].name
							) {
								//console.log("c1")
								nb_diff += this.diff(
									lvl + 1,
									json_1.elements[i1],
									json_2.elements[i2],
									write_1,
									write_2,
									path.concat([
										{
											name: json_1.elements[i1].name,
											nb: i1,
										},
									])
								);
								i1++;
								i2++;
							} else {
								nb_diff++;
								if (keys_2.includes(json_1.elements[i1].name)) {
									//console.log("c2")
									this.diff(
										lvl + 1,
										json_1.elements[i1],
										json_2.elements[
											obj_key_2[json_1.elements[i1].name]
										],
										write_1,
										false,
										path.concat([
											{
												name: json_1.elements[i1].name,
												nb: i1,
											},
										])
									);
									i1++;
								} else {
									//console.log("c3")
									this.diff(
										lvl + 1,
										json_1.elements[i1],
										{},
										write_1,
										false,
										path.concat([
											{
												name: json_1.elements[i1].name,
												nb: i,
											},
										])
									);
									i1++;
								}

								if (keys_1.includes(json_2.elements[i2].name)) {
									//console.log("c4")
									this.diff(
										lvl + 1,
										json_1.elements[
											obj_key_1[json_2.elements[i2].name]
										],
										json_2.elements[i2],
										false,
										write_2,
										path.concat([
											{
												name: json_2.elements[i2].name,
												nb: i2,
											},
										])
									);
									i2++;
								} else {
									//console.log("c5")
									this.diff(
										lvl + 1,
										{},
										json_2.elements[i2],
										false,
										write_2,
										path.concat([
											{
												name: json_2.elements[i2].name,
												nb: i2,
											},
										])
									);
									i2++;
								}
							}
						} else if (i1 < json_1.elements.length) {
							nb_diff++;
							if (keys_2.includes(json_1.elements[i1].name)) {
								//console.log("c6")
								this.diff(
									lvl + 1,
									json_1.elements[i1],
									json_2.elements[
										obj_key_2[json_1.elements[i1].name]
									],
									write_1,
									false,
									path.concat([
										{
											name: json_1.elements[i1].name,
											nb: i1,
										},
									])
								);
								i1++;
							} else {
								//console.log("c7")
								this.diff(
									lvl + 1,
									json_1.elements[i1],
									{},
									write_1,
									false,
									path.concat([
										{
											name: json_1.elements[i1].name,
											nb: i1,
										},
									])
								);
								i1++;
							}
						} else if (i2 < json_2.elements.length) {
							nb_diff++;
							if (keys_1.includes(json_2.elements[i2].name)) {
								//console.log("c8")
								this.diff(
									lvl + 1,
									json_1.elements[
										obj_key_1[json_2.elements[i2].name]
									],
									json_2.elements[i2],
									false,
									write_2,
									path.concat([
										{
											name: json_2.elements[i2].name,
											nb: i2,
										},
									])
								);
								i2++;
							} else {
								//console.log("c9")
								this.diff(
									lvl + 1,
									{},
									json_2.elements[i2],
									false,
									write_2,
									path.concat([
										{
											name: json_2.elements[i2].name,
											nb: i2,
										},
									])
								);
								i2++;
							}
						} else c = false;
					}
					//console.log("--- end loop ---")
				}

				var end_tag_1 = false;
				var end_tag_2 = false;

				if (p) {
					if (json_1.type == "element") {
						if (write_1) {
							//console.log("w13 (" + color + "): " + this.file_1[this.i1]);
							this.result_1.push({
								text: this.xml_object_to_string(
									lvl,
									json_1,
									true
								),
								color,
							});
							this.i1++;
							end_tag_1 = true;
						}
					}

					//console.log("prev 2 : " + text_2)
					if (json_2.type == "element") {
						if (write_2) {
							//console.log("w23 (" + color + "): " + this.file_2[this.i2]);
							this.result_2.push({
								text: this.xml_object_to_string(
									lvl,
									json_2,
									true
								),
								color,
							});
							this.i2++;
							end_tag_2 = true;
						}
					}

					if (end_tag_2 && !end_tag_1) {
						this.result_1.push({
							text: " ",
							color,
						});
					}

					if (end_tag_1 && !end_tag_2) {
						this.result_2.push({
							text: " ",
							color,
						});
					}
				}

				if (nb_diff == 0 && this.only_diff) {
					this.result_1.splice(
						i_result_1,
						this.result_1.length - i_result_1
					);
					this.result_2.splice(
						i_result_2,
						this.result_2.length - i_result_2
					);
				}

				if (lvl == 2) {
					for (var i = i_result_1; i < this.result_1.length; i++) {
						if (this.result_1[i].text == " ") {
							this.result_1.splice(i, 1);
							i_space_1++;
							i--;
						}
					}
					for (var i = i_result_2; i < this.result_2.length; i++) {
						if (this.result_2[i].text == " ") {
							this.result_2.splice(i, 1);
							i_space_2++;
							i--;
						}
					}

					var remove = 0;
					if (i_space_1 < i_space_2) {
						remove = i_space_2 - i_space_1;
						for (var i = 0; i < remove; i++) {
							this.result_2.push({
								text: " ",
								color,
							});
						}
					} else i_space_2 < i_space_1;
					{
						remove = i_space_1 - i_space_2;
						for (var i = 0; i < remove; i++) {
							this.result_1.push({
								text: " ",
								color,
							});
						}
					}
				}

				//console.log("--- end dif ---")

				return nb_diff;
			},
		},
		mounted: async function () {
			var self = this;

			if (store.state.user.rules && !store.state.user.rules.compare) {
				this.$router.push({ name: "profile" });
			}

			var schema = {
				title: "Fichier 1",
				type: "string",
				format: "xml",
			};

			var element = document.getElementById("jsoneditor-1");

			this.editor_1 = new JSONEditor(element, {
				schema: schema,
				theme: "bootstrap4",
				iconlib: "fontawesome5",
				object_background: "",
			});

			await new Promise((resolve, reject) => {
				self.editor_1.on("ready", function () {
					if (resolve) resolve();
				});
			});

			this.editor_1.on("change", function () {
				var text = self.editor_1.getValue();
				if (text) {
					console.log(" --- start ---");
					self.file_1 = format(text, {
						indentation: "  ",
						collapseContent: false,
						filter: (node) => node.type !== "Comment",
						lineSeparator: "\n",
					}).split("\n");
					self.json_1 = convert.xml2js(text);
					self.start_diff();
				}
			});

			var schema = {
				title: "Fichier 2",
				type: "string",
				format: "xml",
			};

			element = document.getElementById("jsoneditor-2");

			this.editor_2 = new JSONEditor(element, {
				schema: schema,
				theme: "bootstrap4",
				iconlib: "fontawesome5",
				object_background: "",
			});

			await new Promise((resolve, reject) => {
				self.editor_2.on("ready", function () {
					if (resolve) resolve();
				});
			});

			this.editor_2.on("change", function () {
				var text = self.editor_2.getValue();
				if (text) {
					console.log(" --- start ---");
					self.file_2 = format(text, {
						indentation: "  ",
						collapseContent: false,
						filter: (node) => node.type !== "Comment",
						lineSeparator: "\n",
					}).split("\n");
					self.json_2 = convert.xml2js(text);
					self.start_diff();
				}
			});
		},
	};
</script>
